import { exportCsv } from 'src/graphql/exportCsv';

export const exportCsvHandler = async (csvMetaData, notificationActions, setIsExportingCsv) => {
  try {
    const csvChainId = csvMetaData?.csv_chain_id;
    const customMultiPromptId = csvMetaData?.customMultiPromptId;

    if (!csvChainId && !customMultiPromptId) {
      return;
    }

    if (setIsExportingCsv) {
      setIsExportingCsv(true);
    }

    const id = csvChainId ? { csvChainId } : { customMultiPromptId };

    const { downloadUrl } = await exportCsv(id);
    window.open(downloadUrl, '_blank');
  } catch {
    notificationActions.displayError({
      message: 'Failed to export CSV. Please try again later.',
    });
  } finally {
    if (setIsExportingCsv) {
      setIsExportingCsv(false);
    }
  }
};
